import styled from 'styled-components';
import Row from '@sdk/components/ui/spacing/Row';

export const ApplyFiltersContainer = styled(Row)`
  padding: 10px;
  margin: 10px 10px 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.colors.bodyBg};
  justify-content: space-between;
  align-items: center;
  height: 56px;
`;
